const IMAGE_SERVER_BASE =
  process.env.REACT_APP_IMAGE_SERVER_BASE || 'https://quuit.com/imageserver';

/** Filenames produced by our HotQuus upload API: `<32-hex>_<safeName>.ext` */
const HOTQUU_UPLOAD_FILENAME = /^[a-f0-9]{32}_.+\.(png|jpe?g|gif|webp|svg)$/i;

function publicAppOrigin(): string {
  const fromEnv = process.env.REACT_APP_API_PUBLIC_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/+$/, '');
  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }
  return (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace(/\/api\/?$/i, '');
}

/**
 * Build a browser-loadable URL for HotQuu campaign artwork (#45).
 * Prefers full http(s) URLs (images uploaded to our server and saved to Quu).
 * Falls back to Quu imageserver paths for legacy filename-only logos.
 */
export function resolveMessageImageUrl(messageId: string, logo: string): string {
  const trimmed = String(logo || '').trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('data:')) return '';

  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  if (trimmed.startsWith('/imageserver/') || trimmed.startsWith('imageserver/')) {
    const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return `https://quuit.com${path}`;
  }
  // Absolute path on our API / CDN (e.g. /uploads/xyz.png)
  if (trimmed.startsWith('/')) {
    return `${publicAppOrigin()}${trimmed}`;
  }
  if (trimmed.includes('/')) {
    return trimmed;
  }

  // Quu often stores only the basename after save. Prefer our /uploads/ CDN when
  // the name matches HotQuus upload filenames so images keep working even if Quu
  // did not re-host them on imageserver.
  if (HOTQUU_UPLOAD_FILENAME.test(trimmed)) {
    return `${publicAppOrigin()}/uploads/${encodeURIComponent(trimmed).replace(/%2F/gi, '/')}`;
  }

  const id = encodeURIComponent(String(messageId));
  // Keep query strings on legacy filenames (e.g. file.jpg?date=...)
  const qIndex = trimmed.indexOf('?');
  const filePart = qIndex >= 0 ? trimmed.slice(0, qIndex) : trimmed;
  const query = qIndex >= 0 ? trimmed.slice(qIndex) : `?date=${Date.now()}`;
  const file = encodeURIComponent(filePart);
  return `${IMAGE_SERVER_BASE}/EmergencyBlastCampaigns/${id}/${file}${query.startsWith('?') ? query : `?${query}`}`;
}
